var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewCorporateIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#3F8CFF",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6 15.9984H17.6V22.3984H21.6C22.0418 22.3984 22.4 22.0403 22.4 21.5984V16.7984C22.4 16.3566 22.0418 15.9984 21.6 15.9984ZM16 14.3984V23.9984H21.6C22.9255 23.9984 24 22.9239 24 21.5984V16.7984C24 15.473 22.9255 14.3984 21.6 14.3984H16Z",
    fill: "#3F8CFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8031 18.4016C20.8031 17.9597 20.445 17.6016 20.0031 17.6016C19.5613 17.6016 19.2031 17.9597 19.2031 18.4016C19.2031 18.8434 19.5613 19.2016 20.0031 19.2016C20.445 19.2016 20.8031 18.8434 20.8031 18.4016Z",
    fill: "#3F8CFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8031 20.8016C20.8031 20.3597 20.445 20.0016 20.0031 20.0016C19.5613 20.0016 19.2031 20.3597 19.2031 20.8016C19.2031 21.2434 19.5613 21.6016 20.0031 21.6016C20.445 21.6016 20.8031 21.2434 20.8031 20.8016Z",
    fill: "#3F8CFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4 24C9.07452 24 8 22.9255 8 21.6V10.4C8 9.07452 9.07452 8 10.4 8H15.2C16.5255 8 17.6 9.07452 17.6 10.4V24H10.4ZM10.4 9.6H15.2C15.6418 9.6 16 9.95817 16 10.4V22.4H14.4V21.6C14.4 21.1582 14.0418 20.8 13.6 20.8H12C11.5582 20.8 11.2 21.1582 11.2 21.6V22.4H10.4C9.95817 22.4 9.6 22.0418 9.6 21.6V10.4C9.6 9.95817 9.95817 9.6 10.4 9.6Z",
    fill: "#3F8CFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6031 11.1992C14.045 11.1992 14.4031 11.5574 14.4031 11.9992C14.4031 12.441 14.045 12.7992 13.6031 12.7992H12.0031C11.5613 12.7992 11.2031 12.441 11.2031 11.9992C11.2031 11.5574 11.5613 11.1992 12.0031 11.1992H13.6031Z",
    fill: "#3F8CFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6031 14.3992C14.045 14.3992 14.4031 14.7574 14.4031 15.1992C14.4031 15.641 14.045 15.9992 13.6031 15.9992H12.0031C11.5613 15.9992 11.2031 15.641 11.2031 15.1992C11.2031 14.7574 11.5613 14.3992 12.0031 14.3992H13.6031Z",
    fill: "#3F8CFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4031 18.3992C14.4031 17.9574 14.045 17.5992 13.6031 17.5992H12.0031C11.5613 17.5992 11.2031 17.9574 11.2031 18.3992C11.2031 18.841 11.5613 19.1992 12.0031 19.1992H13.6031C14.045 19.1992 14.4031 18.841 14.4031 18.3992Z",
    fill: "#3F8CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCorporateIcon);
export default __webpack_public_path__ + "static/media/new-corporate-icon.02a1be70c124b2d8784c45299d060149.svg";
export { ForwardRef as ReactComponent };